import React from 'react'
import SelectBox from '../common/SelectBox'

class ResidentialStatus extends React.Component {
  render() {
    const {
      checked,
      onChange,
      disabled,
    } = this.props

    return(
      <div>
        <div className='grey smaller mb-2'>What is your residential situation?</div>
        <SelectBox
          checked={ checked === 'own' }
          disabled={ disabled }
          name={'residentail-situation'}
          value={'own'}
          text={'I own my home'}
          style={'d-inline-block'}
          onChange={ onChange }
        />
        <SelectBox
          checked={ checked === 'rent' }
          disabled={ disabled }
          name={'residentail-situation'}
          value={'rent'}
          text={'I am renting'}
          style={'d-inline-block'}
          onChange={ onChange }
        />
        <SelectBox
          checked={ checked === 'parents' }
          name={'residentail-situation'}
          disabled={ disabled }
          value={'parents'}
          text={'I live with parents/relatives'}
          style={'d-inline-block'}
          onChange={ onChange }
        />
      </div>
    )
  }
}

export default ResidentialStatus;
